import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  id: "show-less-icon",
  role: "img",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", { d: "M3 11.4643C2.58579 11.4643 2.25 11.1285 2.25 10.7143C2.25 10.3001 2.58579 9.96429 3 9.96429H9.96429V3C9.96429 2.58579 10.3001 2.25 10.7143 2.25C11.1285 2.25 11.4643 2.58579 11.4643 3V10.7143C11.4643 11.1285 11.1285 11.4643 10.7143 11.4643H3Z" }, null, -1),
    _createElementVNode("path", { d: "M21 12.5357C21.4142 12.5357 21.75 12.8715 21.75 13.2857C21.75 13.6999 21.4142 14.0357 21 14.0357H14.0357V21C14.0357 21.4142 13.6999 21.75 13.2857 21.75C12.8715 21.75 12.5357 21.4142 12.5357 21V13.2857C12.5357 12.8715 12.8715 12.5357 13.2857 12.5357H21Z" }, null, -1)
  ])))
}
export default { render: render }